// Package Imports
import React, { lazy, Suspense } from 'react';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import { Route } from 'react-router-dom';
import Loading from 'components/loading/loading';

// Project Imports
const TeamPerformance = lazy(
  () => import('pages/teamPerformance/teamPerformance')
);
const TeamMemberPerformanceDashboard = lazy(
  () => import('pages/teamMemberPerformance/TeamMemberPerformance')
);
const TeamleadDashboardRoute = (
  <Route path={routeName.teamLeadDashboard}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.TEAMLEAD_DASHBOARD}>
          <Suspense fallback={<Loading />}>
            <TeamPerformance />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="show/:id"
      element={
        // <PrivateRoute name={PrivateRouteConst.TEAMLEAD_DASHBOARD}>
        <TeamMemberPerformanceDashboard />
        // </PrivateRoute>
      }
    />
  </Route>
);

export default TeamleadDashboardRoute;
